import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ERP_NEXT_IMPORT_MODE } from './components/cfg';
import * as erp_next_import from './components/erp_next_export';

if (!ERP_NEXT_IMPORT_MODE) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  window._ = erp_next_import;
}
